<h1>Upravne stvari</h1>
<p-button label="Ažuriraj upravne stvari" (onClick)="updateUpravneStvari()"></p-button>
<div class="card">
    <p-treeTable [value]="upravneStvari$ | async" [scrollable]="true" [tableStyle]="{'min-width':'50rem'}">
        <ng-template pTemplate="header">
            <tr>
                <th>Naziv</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ttRow]="rowNode">
                <td>
                    <p-treeTableToggler [rowNode]="rowNode" />
                    {{ rowData.label }}
                </td>
            </tr>
        </ng-template>
    </p-treeTable>
</div>